'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _components = require('../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getCoverLotUrls2 = require('../../utils/getCoverLotUrls');

var _getCoverLotUrls3 = _interopRequireDefault(_getCoverLotUrls2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CoverLots = require('./CoverLots.scss');

var _CoverLots2 = _interopRequireDefault(_CoverLots);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoverLots = (_temp = _class = function (_PureComponent) {
    (0, _inherits3.default)(CoverLots, _PureComponent);

    function CoverLots() {
        (0, _classCallCheck3.default)(this, CoverLots);
        return (0, _possibleConstructorReturn3.default)(this, (CoverLots.__proto__ || (0, _getPrototypeOf2.default)(CoverLots)).apply(this, arguments));
    }

    (0, _createClass3.default)(CoverLots, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                catalogId = _props.catalogId,
                catalogUrl = _props.catalogUrl,
                className = _props.className,
                coverLots = _props.coverLots,
                featured = _props.featured,
                sellerId = _props.sellerId;

            var _getCoverLotUrls = (0, _getCoverLotUrls3.default)(catalogId, coverLots, sellerId, featured, catalogUrl),
                primary = _getCoverLotUrls.primary,
                secondary1 = _getCoverLotUrls.secondary1,
                secondary2 = _getCoverLotUrls.secondary2;

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_CoverLots2.default['cover-lots']]).join(' ').trim();

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: primary.imageHref,
                className: _CoverLots2.default['primary-img-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _CoverLots2.default.primary,
                src: primary.imageSrc,
                alt: primary.imageAlt
            })), (0, _jsx3.default)('div', {
                className: _CoverLots2.default['secondary-img-container']
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: secondary1.imageHref,
                className: _CoverLots2.default['img-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _CoverLots2.default.secondary,
                src: secondary1.imageSrc,
                alt: secondary1.imageAlt
            })), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: secondary2.imageHref,
                className: _CoverLots2.default['img-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _CoverLots2.default.secondary,
                src: secondary2.imageSrc,
                alt: secondary2.imageAlt
            }))));
        }
    }]);
    return CoverLots;
}(_react.PureComponent), _class.defaultProps = {
    className: ''
}, _temp);
exports.default = CoverLots;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CoverLots/CoverLots.js
// module id = L9QP
// module chunks = 57